import { getIdentity } from './Identity';
import { getCatalogueTitle } from './Catalogue';
import { startChat as userStartChat } from './User';
import I18n from './I18n';
import { getCurrentRouteName, isResellerViewRoute, NAME as ROUTE_NAME } from './Route';
import { onHomeChatClick, onGalleryChatClick, onCustomPageChatClick } from './Events';
import { isCustomPage } from './Amalgam';

let action1 = null;
let initMessage1Sent = false;
let initMessage2Sent = false;
let phoneMessageSent = false;
let connectWhatsapp = false;

export const startChat = ({ callNativeHandler = false } = {}) =>
  getIdentity().then((identity) => {
    const identityName = identity.name;
    const catalogueTitle = getCatalogueTitle();

    if (identityName && catalogueTitle) {
      return userStartChat({
        message: I18n.t('START_CHAT_NAME_CATALOGUE_TEXT', {
          name: identityName,
          catalogue: catalogueTitle
        }),
        callNativeHandler
      });
    }

    if (identityName) {
      return userStartChat({
        message: I18n.t('START_CHAT_NAME_TEXT', {
          name: identityName
        }),
        callNativeHandler
      });
    }

    if (catalogueTitle) {
      return userStartChat({
        message: I18n.t('START_CHAT_CATALOGUE_TEXT', {
          catalogue: catalogueTitle
        }),
        callNativeHandler
      });
    }

    return userStartChat({ message: I18n.t('START_CHAT_TEXT'), callNativeHandler });
  });

export const didSendInit1Message = () => initMessage1Sent;
export const sendInit1Message = () => {
  initMessage1Sent = true;
};

export const didSendInit2Message = () => initMessage2Sent;
export const sendInit2Message = () => {
  initMessage2Sent = true;
};

export const didSendPhoneMessage = () => phoneMessageSent;
export const sendPhoneMessage = () => {
  phoneMessageSent = true;
};

export const getAction1 = () => action1;
export const setAction1 = (action) => {
  action1 = action;
};

export const didConnectWhatsapp = () => connectWhatsapp;
export const setConnectWhatsapp = () => {
  connectWhatsapp = true;
};

export const createSelectedProductUrlForChat = ({ selectedPictureId } = {}) =>
  `${window.location.protocol}//${window.location.host}${window.location.pathname}?imageId=${selectedPictureId}`;

export const getDTWidgetDefaultMessage = (connectParams) => {
  const currentRoute = getCurrentRouteName();
  const fromReseller = isResellerViewRoute(currentRoute);

  if (
    currentRoute === ROUTE_NAME.HOME ||
    currentRoute === ROUTE_NAME.COMPANY_DETAIL ||
    currentRoute === ROUTE_NAME.RESELLER_CATALOGUE_HOME
  ) {
    return startChat({ callNativeHandler: fromReseller });
  }

  if (isCustomPage()) {
    return startChat({ callNativeHandler: fromReseller });
  }

  if (
    currentRoute === ROUTE_NAME.GALLERY ||
    currentRoute === ROUTE_NAME.RESELLER_CATALOGUE_GALLERY
  ) {
    const url = createSelectedProductUrlForChat(connectParams);
    return Promise.resolve(
      userStartChat({
        message: `${I18n.t('KNOW_MORE_ABOUT_ITEM')}\n\n${url}`,
        callNativeHandler: fromReseller
      })
    );
  }

  return Promise.resolve({});
};

export const onConnectWhatsAppClick = (connectParams, openInNative) => {
  const currentRoute = getCurrentRouteName();
  const fromReseller = isResellerViewRoute(currentRoute);

  if (
    currentRoute === ROUTE_NAME.HOME ||
    currentRoute === ROUTE_NAME.COMPANY_DETAIL ||
    currentRoute === ROUTE_NAME.RESELLER_CATALOGUE_HOME
  ) {
    onHomeChatClick({ callNativeHandler: fromReseller });
    return startChat({ callNativeHandler: fromReseller, openInNative });
  }

  if (isCustomPage()) {
    onCustomPageChatClick({ callNativeHandler: fromReseller });
    return startChat({ callNativeHandler: fromReseller, openInNative });
  }

  if (
    currentRoute === ROUTE_NAME.GALLERY ||
    currentRoute === ROUTE_NAME.RESELLER_CATALOGUE_GALLERY
  ) {
    const { productId, selectedPictureId } = connectParams || {};

    onGalleryChatClick({ productId, callNativeHandler: fromReseller });

    const url = createSelectedProductUrlForChat({ selectedPictureId });

    return Promise.resolve(
      userStartChat({
        message: `${I18n.t('KNOW_MORE_ABOUT_ITEM')}\n\n${url}`,
        callNativeHandler: fromReseller,
        openInNative
      })
    );
  }
  return Promise.resolve({});
};

export const getDTChatInstance = () => window.dt;

let updateDtChatConfigInterval = null;
export const updateDtChatConfig = (config) => {
  if (updateDtChatConfigInterval) {
    clearInterval(updateDtChatConfigInterval);
  }
  updateDtChatConfigInterval = setInterval(() => {
    const dtChat = getDTChatInstance();
    if (!window.DtWidgetLoaded || !dtChat || !dtChat.setConfig) {
      return;
    }
    dtChat.setConfig(config);
    clearInterval(updateDtChatConfigInterval);
  }, 100);
};

let updateDtChatStylesInterval = null;
export const updateDtChatStyles = (styles) => {
  if (updateDtChatStylesInterval) {
    clearInterval(updateDtChatStylesInterval);
  }
  updateDtChatStylesInterval = setInterval(() => {
    const dtChat = getDTChatInstance();
    if (!window.DtWidgetLoaded || !dtChat || !dtChat.setConfig) {
      return;
    }
    dtChat.setConfig({ styles });
    clearInterval(updateDtChatStylesInterval);
  }, 100);
};

let setShowDtChatInterval = null;
export const setShowDtChat = (show = true) => {
  if (setShowDtChatInterval) {
    clearInterval(setShowDtChatInterval);
  }
  setShowDtChatInterval = setInterval(() => {
    const dtChat = getDTChatInstance();
    if (!window.DtWidgetLoaded || !dtChat || !dtChat.setHideWidget) {
      return;
    }
    dtChat.setHideWidget(!show);
    clearInterval(setShowDtChatInterval);
  }, 100);
};

let setOpenDtModalInterval = null;
export const setOpenDtModal = (isOpen = false) => {
  if (setOpenDtModalInterval) {
    clearInterval(setOpenDtModalInterval);
  }
  setOpenDtModalInterval = setInterval(() => {
    const dtChat = getDTChatInstance();
    if (!window.DtWidgetLoaded || !dtChat || !dtChat.setIsOpen) {
      return;
    }
    dtChat.setIsOpen(isOpen);
    clearInterval(setOpenDtModalInterval);
  }, 100);
};

let resetDtChatConfigInterval = null;
export const resetDtChatConfig = () => {
  if (resetDtChatConfigInterval) {
    clearInterval(resetDtChatConfigInterval);
  }
  resetDtChatConfigInterval = setInterval(() => {
    const dtChat = getDTChatInstance();
    if (!window.DtWidgetLoaded || !dtChat || !dtChat.resetConfig) {
      return;
    }
    dtChat.resetConfig();
    clearInterval(resetDtChatConfigInterval);
  }, 100);
};

export const registerDTWidgetDefaultMessage = (connectParams = {}, productParams = {}) => {
  getDTWidgetDefaultMessage(connectParams)
    .then(({ message, phone }) => {
      if (!message && !phone) {
        return;
      }
      const newConfig = {};
      if (message) {
        newConfig.text = { defaultMessage: message };
      }
      if (phone) {
        newConfig.phoneNumber = phone;
      }
      updateDtChatConfig({
        ...newConfig,
        ...productParams,
        chatWidgetOpened: () => onConnectWhatsAppClick(connectParams)
      });
    })
    .catch(() => {
      // Handle error
    });
};
